<div class="volumeUp">
    <div (click)="stop()" *ngIf="isPlaying">
        <fa-icon [icon]="['fas','volume-up']"></fa-icon>
    </div>
    <div (click)="play()" *ngIf="!isPlaying">
        <fa-icon [icon]="['fas','volume-mute']"></fa-icon>
    </div>
</div>